module.exports = __webpack_public_path__ + "static/media/galerija_2021 (5)-min.973ed9cd.jpg";